import { IMdCmFields } from "../types/AppTypes";
import { MdEnableStatusEnum } from "../types/AppEnums";

//系统标识  测试和生产主数据标识区别
export const CLIENT_APP_CODE = "bms";

export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 300000;

//API请求环境
const baseRequestUrl = {
	// "DEV": "http://192.168.194.55:5656",
	"TEST": "http://81.70.147.117:9479",
	"DEV": "http://api.peijian88.cn",
	"STAGE": "http://api.beiben88.com",
	// "TEST": "http://api-2.laoniuche.cn",
	//"PROD": "https://api-2.yunhaogroup.com"
	PROD:"http://api-prod.yunhaogroup.com",
}

//鉴权2的请求环境
const baseAuth2RequestUrl = {
	"DEV": "http://api.peijian88.cn",
	"STAGE": "http://api.beiben88.com",
	"TEST": "http://api-2.laoniuche.cn",
	//"PROD": "https://api-2.yunhaogroup.com"
	PROD:"http://api-prod.yunhaogroup.com",
}

//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
	//自动选择环境
	//....
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return baseRequestUrl[REACT_APP_ENV ?? "DEV"] + "/bms"
	// return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//根据环境变量自动获取鉴权请求地址
export const getBaseAuth2RequestUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return baseAuth2RequestUrl[REACT_APP_ENV ?? "DEV"]
};

//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "token";

//获取token
export const getToken = () => {
	return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};

//存储token
export const setToken = (token: string) => {
	sessionStorage.setItem(TOKEN_KEY, token)
};
//通用字段定义
export const defaultMdCmParam: IMdCmFields = {
	sourceApp: "bms",
	sourceAuthKey: "",
	branch: "bms",
	ver: undefined,
	enable: MdEnableStatusEnum.ENABLE,
};

export const branchDs = [
	{ label: "财务分支", value: "fms" },
	{ label: "主分支", value: "main" },
	{ label: "供应链分支", value: "scm" },
]